import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/components/VideoPageClient.tsx");
